module.exports = __webpack_public_path__ + "img/full_working.ab38e3e9.svg";